import { render, staticRenderFns } from "./loan-term-lender-info.vue?vue&type=template&id=020106fb"
import script from "./loan-term-lender-info.vue?vue&type=script&lang=js"
export * from "./loan-term-lender-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports